module.exports = __webpack_public_path__ + "img/banners_success_with_undo.e0b95d5b.webp";